import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController } from 'ionic-angular';

@Component({
  selector: 'page-usuarios-editar',
  templateUrl: 'usuarios-editar.html',
})
export class UsuariosEditarPage {
  usuarioData:any[] = []
  clavePedido: string = "";
  errorClave: string = "";
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController) {
   if(this.navParams.get('usuariosData')){
      this.usuarioData = this.navParams.get('usuariosData')
    }
  }

  ionViewDidLoad() {}

  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
   this.viewControllers.dismiss(this.usuarioData);
  }

  validarClave() {
    if (!/^\d{1,4}$/.test(this.clavePedido)) {
      this.errorClave = "La clave debe ser un número entre 1 y 4 dígitos.";
    } else {
      this.errorClave = "";
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/usuarios/usuarios-editar/usuarios-editar.ts